<template>
  <div>
    <img
      src="@/assets/tarjeta_beneficios_cesur.jpg"
      style="width: 100%"
    />
    <p class="tituloTarjeta">¡TU FIDELIDAD SE PREMIA!</p>
    <p>Estudiar, reciclarse o ayudar a que tu hijo/a encuentre su camino profesional son decisiones que marcan el futuro.</p>
    <p>Hoy puedes hacerlo en el <b>Centro Oficial de FP CESUR</b> con ventajas exclusivas por ser cliente de <b>MMT Seguros</b>:</p>
    
    <ul class="cesurLista">
      <li><b>20% de descuento</b> en ciclos presenciales con el código <b>#EMPRESA20</b></li>
      <li><b>40% de descuento</b> en ciclos online con el código <b>#EMPRESA40</b></li>
    </ul>
    
    <p> Es el momento. ¡Infórmate sin compromiso! ;)</p>

    <p class="container-flex">
      <a
        href=" https://lider.cesurformacion.com/mmt-seguros/?medio=10%20-%20Acuerdos%20comerciales&utm_campaign=2025_mail_bbdd_mmt_seguros"
        target="_blank"
        class="link"
      >
        <button class="pure-button botonLlamar">Quiero saber más</button>
      </a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    email() {},
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-bottom: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

ul {
  list-style: none; 
  padding: 0;
  margin: 0;
}

ul li::before {
  content: "➠"; 
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

.link {
  color: $colorMMT;
  font-weight: 460;
  margin-right: 3rem;
}
</style>
